import { DETAIL_SEARCH_TYPE, PROJECT_STATUS, PROPERTY_STATUS } from '../../common/constants'
import { propertyDetailSearchFields } from '../../common/forms/generalRealEstate/fields'
import { projectDetailSearchFields } from '../../common/forms/projects/fields'
import { stateKey } from './actions'

export const selectQuickSearchCriteria = (state) => state[stateKey]?.quickSearchCriteria
export const selectDetailSearchCriteria = (state) => state[stateKey]?.detailSearchCriteria

// Default criteria used when nothing has been searched yet - a display/selector-level fallback, not stored state
export const detailSearchDefaultCriteria = {
    [DETAIL_SEARCH_TYPE.PROJECT]: {
        [projectDetailSearchFields.PROJECT_STATUS]: [
            PROJECT_STATUS.PREPARATION.toString(),
            PROJECT_STATUS.FOR_AUTHORIZATION.toString(),
            PROJECT_STATUS.ACTIVE.toString(),
        ],
    },
    [DETAIL_SEARCH_TYPE.PROPERTY]: {
        [propertyDetailSearchFields.PROPERTY_STATUS]: [PROPERTY_STATUS.ACTIVE_OFFER.toString(), PROPERTY_STATUS.FOR_AUTHORIZATION.toString()],
    },
    [DETAIL_SEARCH_TYPE.CONTACT]: {},
    [DETAIL_SEARCH_TYPE.COMPANY]: {},
    [DETAIL_SEARCH_TYPE.DOCUMENT]: undefined,
    [DETAIL_SEARCH_TYPE.INTERMEDIARY_DIARY]: undefined,
    [DETAIL_SEARCH_TYPE.EVIDENCE_DIARY]: undefined,
}

// Defaults to quick search if set, then to detail search if searchType matches, otherwise falls back to default detail search criteria.
// supportsQuickSearch: quick search is only available for project/property/contact/company lists (see QuickSearchInput.js)
const createSearchCriteriaSelector = (type, supportsQuickSearch = false) => (state) => {
    if (supportsQuickSearch && state[stateKey]?.quickSearchCriteria) {
        return state[stateKey].quickSearchCriteria
    }

    const detailSearchCriteria = state[stateKey]?.detailSearchCriteria

    if (detailSearchCriteria?.searchType === type) {
        return detailSearchCriteria.criteria
    }

    return detailSearchDefaultCriteria[type]
}

export const selectSearchCriteriaContacts = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.CONTACT, true)
export const selectSearchCriteriaCompanies = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.COMPANY, true)
export const selectSearchCriteriaProperties = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.PROPERTY, true)
export const selectSearchCriteriaProjects = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.PROJECT, true)
export const selectSearchCriteriaDocuments = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.DOCUMENT)
export const selectSearchCriteriaIntermediaryDiaries = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.INTERMEDIARY_DIARY)
export const selectSearchCriteriaEvidenceDiaries = createSearchCriteriaSelector(DETAIL_SEARCH_TYPE.EVIDENCE_DIARY)
